import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import TextTruncate from 'react-text-truncate'

function NewsFeedArticle({
  title, summary, url, image, createdAt,
}) {
  return (
    <div className="card-wrapper news-article-wrapper">
      <div className="card news-article">
        <div className="news-article__image">
          <img src={image} alt={title} />
        </div>
        <div className="news-article__content">
          <div className="news-article__content-header">
            <h3 className="text-bold u-m0">
              <a href={url} target="_blank" rel="nofollow" className="heading-24 text-undecorated">
                <TextTruncate
                  text={title}
                  truncateText="..."
                  line={4}
                />
              </a>
            </h3>
            <div className="text-light-grey">
              <small>{moment(createdAt).format('MMM DD, YYYY')}</small>
            </div>
            <TextTruncate
              containerClassName="text-default article-summary"
              text={summary}
              truncateText="..."
              line={3}
            />
          </div>
          <div className="u-text-center article-button">
            <a href={url} target="_blank" rel="nofollow" className="btn btn-outline-default">Read more</a>
          </div>
        </div>
      </div>
    </div>
  )
}

NewsFeedArticle.propTypes = {
  title: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
}

export default NewsFeedArticle
